import "./index.scss";
import { GcxLogo } from "../gcx-logo";

export const PortalFooterBrand = () => {
  return (
    <div className="portal-footer-brand">
      <GcxLogo version="invert" data-testid="gcx-logo" />
      <p>Save everywhere you shop with up to 30% off thousands of brands.</p>
    </div>
  );
};
